import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sale-update-profile',
  templateUrl: './sale-update-profile.component.html',
  styleUrls: ['./sale-update-profile.component.scss']
})
export class SaleUpdateProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
